import apiService from '@/api/apiService';

export const editRole = async (roleId, data) => {
    const url = `/api/admin/roles/${roleId}`;

    return apiService.PUT(url, data);
};
